// extracted by mini-css-extract-plugin
export default {"formWrapper":"item-detail-form_formWrapper__B33Yw","actionBtnWrapper":"item-detail-form_actionBtnWrapper__RmvuL","nextBtn":"item-detail-form_nextBtn__Nok3M"};